export const ObjectTypeSelector = ( { allObjectTypes, searchOnClick } ) => {
	const { _n } = wp.i18n;

	// A filter is applied so you can re-order the object types, or remove some. By default remove remove product_variation (since those are shown under
	// Products anyway)
	const filteredObjectTypes = wp.hooks.applyFilters(
		'qalaElasticCore.filter.objectTypeSelector.allObjectTypes',
		allObjectTypes
			.filter( objectType => {
				return objectType?.name && objectType.name !== 'product_variation';
			} )
	);

	return (
		<div className="qec-results__object-type-selector">
			{ filteredObjectTypes.map( singleObjectType => {
				const classes = [ 'btn' ];
				if ( ! singleObjectType.isActive ) {
					classes.push( 'btn-type-3' );
				}
				return (
					<button
						className={ classes.join( ' ' ) }
						key={ singleObjectType.name }
						onClick={ () => searchOnClick( singleObjectType.name ) }
						aria-expanded={ singleObjectType.isActive ? 'true' : 'false' }
					>
						{ singleObjectType.namePretty || singleObjectType.name } ({ singleObjectType.count }<span className="screen-reader-text">{ _n( ' result', ' results', singleObjectType.count, 'qala-elastic-core' ) }</span>)
					</button>
				);
			} ) }
		</div>
	);
};
